// extracted by mini-css-extract-plugin
export var downArrow = "_j7-0";
export var infoTooltipIcon = "_j7-3";
export var label = "_j7-1";
export var optionCard = "_j7-4";
export var upArrow = "_j7-2";